import { useState, useEffect } from "react";
import AuthorizationINSSSection from "./components/AuthorizationINSSSection";
import { AUTHORIZATION_FIELDS } from "./components/authorizationFields";
import api from "../../api/axios";
import { Box, Button } from "@mui/material";
import { CommonSubHeader } from "../../Components/helpers/Helpers";

const Settings = () => {
  const [authorizationFiles, setAuthorizationFiles] = useState({});
  const [existingFiles, setExistingFiles] = useState([]);

  const handleFileChange = (key, file) => {
    setAuthorizationFiles((prev) => ({
      ...prev,
      [key]: file,
    }));
  };

  const saveFiles = async () => {
    const formData = new FormData();

    Object.entries(authorizationFiles).forEach(([key, file]) => {
      if (file) {
        formData.append(key, file);
      }
    });

    await api.post("/caseconfigdocuments/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  const loadExistingFiles = async () => {
    const { data } = await api.get("/caseconfigdocuments/list");

    console.log(data);
    setExistingFiles(data);
  };

  const getFilesByKey = (key) => {
    return existingFiles.filter((file) => file.name.startsWith(key));
  };

  useEffect(() => {
    loadExistingFiles();
  }, []);

  const content = (
    <Box
      sx={{
        padding: "10px",
      }}>
      <Box>
        <AuthorizationINSSSection
          fields={AUTHORIZATION_FIELDS}
          files={authorizationFiles}
          existingFiles={existingFiles}
          onFileChange={handleFileChange}
        />
      </Box>
      <Box sx={{ mt: 2, display: "flex", justifyContent: "end" }}>
        <Button variant="contained" color="success" onClick={saveFiles}>
          Guardar autorizaciones
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      <CommonSubHeader title="Configuración" subTitle="Expedientes" />

      {content}
    </>
  );
};

export default Settings;
